import axios from '@/libs/api.request'

/**
 * get请求
 * @param url
 * @param params
 * @returns {AxiosPromise | *}
 */
export function dataGet (url, params) {
  return axios.request({
    url: url,
    method: 'get',
    params
  })
}

/**
 * 创建
 * @param url
 * @param data
 * @returns {*}
 */
export const dataPost = (url, data) => {
  return axios.request({
    url: url,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js